module.exports = __webpack_public_path__ + "static/img/4-2.bff8fcb6.png";